
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(2.83 .995)","stroke":"#000","stroke-width":"1.5","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M9.538 4.717l7.199-1.966-7.2-1.963a1.387 1.387 0 00-.724 0L1.605 2.75l7.204 1.966c.238.065.49.065.729 0zM13.986 6.561V3.503M5.044 3.69v2.589M1.605 2.752v2.751"}}),_c('circle',{attrs:{"cx":"5.732","cy":"8.942","r":"2.751"}}),_c('path',{attrs:{"d":"M5.732 8.599a.344.344 0 00-.344.343M6.076 8.942a.344.344 0 00-.344-.343M5.732 9.286c.19 0 .344-.154.344-.344M5.388 8.942c0 .19.154.344.344.344"}}),_c('circle',{attrs:{"cx":"12.61","cy":"8.942","r":"2.751"}}),_c('path',{attrs:{"d":"M12.61 8.599a.344.344 0 00-.344.343M12.954 8.942a.344.344 0 00-.344-.343M12.61 9.286c.19 0 .344-.154.344-.344M12.266 8.942c0 .19.154.344.344.344M6.863 11.45l2.308 2.307 2.307-2.306"}}),_c('path',{attrs:{"d":"M14.673 13.756V15.9a5.502 5.502 0 11-11.005 0v-2.143"}}),_c('path',{attrs:{"d":"M14.88 10.498a2.872 2.872 0 013.232 2.82v1.895a4.784 4.784 0 01-5.256 4.715M3.354 10.328a2.888 2.888 0 00-3.125 2.878v1.926a4.816 4.816 0 005.257 4.796"}})])])
          )
        }
      }
    